import React from 'react'
import { Button, Input, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const getSearchFilter = (value, onChange, onSearch, onClear) => {
  return ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    return (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          placeholder={`Введите наименование`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              onSearch()
              confirm()
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Поиск
          </Button>
          <Button
            onClick={() => {
              onClear()
              confirm()
            }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
        </Space>
      </div>
    )
  }
}

export default getSearchFilter
